import { Command } from "ckeditor5";
// @ts-ignore
import AiSummarizeResponseModel from "./aiSummarizeResponseModel";
// @ts-ignore
import Messenger from "messaging/messenger";
// @ts-ignore
import i18next from "i18n/i18n";
import { getSelectedOrAllText } from "./responseTransformationPluginUtil";
import SummarizeResponseUI from "./summarizeResponseUI";

export const SUMMARIZE_RESPONSE = "summarizeResponse";

export default class SummarizeResponseCommand extends Command {
  async execute(): Promise<void> {
    const editor = this.editor;
    const { text, isSelection } = getSelectedOrAllText(editor);
    if (!text || !text.trim()) {
      return;
    }

    const localeId = editor.config.get("languageId");

    if (!localeId) {
      Messenger.okDialog(i18next.t("ai.error.summarizeResponseMissingLocaleError"));
      return;
    }

    this.isEnabled = false;
    Messenger.vent.trigger("show:saving:display");

    try {
      const model = new AiSummarizeResponseModel.responseSummarize({
        isHtml: !isSelection,
        response: text,
        targetLocaleId: localeId,
      });

      await model.saveModelPromise();
      const summaryText = model.get("response");
      if (summaryText) {
        const summarizeResponseUI: SummarizeResponseUI = editor.plugins.get(SummarizeResponseUI);
        summarizeResponseUI.showSummaryDialog(summaryText);
      } else {
        Messenger.okDialog(i18next.t("ai.summarize.empty"));
      }
    } catch (error) {
      console.error("Summarize response failed", error);
      Messenger.okDialog(error || i18next.t("ai.error.summarizeResponseError"));
    } finally {
      Messenger.vent.trigger("close:saving:display");
      this.isEnabled = true;
    }
  }
}
